import React, { useState, useContext } from 'react';
import Accordion from '../../../../../../components/Accordion/Accordion';
import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';
import DatePicker from '../../../../../../components/TextFields/DatePicker';
import { store } from './reducer';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import UsersChip from '../../../../../../components/Chip/UsersChip/UsersChip';
import useRules from 'hooks/useRules';
import { Button } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import { useMainStore } from 'useStores/useMainStore';
import { store as mainStore } from '../../../../../../store';
import axios from 'api/axios';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobile
      ? '1fr 1fr'
      : '250px 250px 1fr 150px 150px 150px',
    gridGap: theme.spacing(1),
    '& > *': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
}));

const Filters = () => {
  const classes = useStyles();
  const [rules, hasRule, isAdmin] = useRules();
  const {
    state: {
      Auth: { profile },
    },
  } = useContext(mainStore);

  const {
    state: {
      startDate,
      endDate,
      progress,
      customers,
      drivers,
      operators,
      page,
      user,
    },
    dispatch,
  } = useContext(store);
  const limit = useMainStore((state) => state.limit);

  const handleChangeStartDate = (date) => {
    dispatch({ type: 'CHANGE_START_DATE', payload: date });
  };
  const handleChangeEndDate = (date) => {
    dispatch({ type: 'CHANGE_END_DATE', payload: date });
  };
  const handleChangeCheckbox = (e) => {
    const { checked, name } = e.target;
    dispatch({ type: 'CHANGE_CHECKBOXES', payload: { name, checked } });
  };
  const handleChangeUser = (user) => {
    dispatch({ type: 'CHANGE_USER', payload: user });
  };

  const handleDownloadExcel = async () => {
    try {
      dispatch({ type: 'PROGRESS', payload: true });
      const {
        data: { downloadLink },
      } = await axios.post(
        `/api/v1/admin/reports/commissionDepositsForMonth?download=excel`,
        {
          startDate,
          endDate,
          customers,
          drivers,
          operators,
          page,
          limit,
          user:
            hasRule('can_manage_operators') || isAdmin
              ? user?.[0]?._id
              : profile._id,
        }
      );
      window.open(downloadLink, '_blank');
    } catch (error) {
      console.error(error);
    }
    dispatch({ type: 'PROGRESS', payload: false });
  };

  return (
    <Accordion title="فیلترهای گزارش" open>
      <div className={classes.root}>
        <DatePicker
          label="از ماه"
          value={startDate}
          onChange={handleChangeStartDate}
          disabled={progress}
          style={{ width: 'fit-content' }}
        />
        <DatePicker
          label="تا ماه"
          value={endDate}
          onChange={handleChangeEndDate}
          disabled={progress}
          style={{ width: 'fit-content' }}
        />
        {hasRule('can_manage_operators') && (
          <UsersChip single onChange={handleChangeUser} />
        )}
        {hasRule('can_manage_operators') && (
          <FormControlLabel
            control={
              <Checkbox
                checked={customers}
                onChange={handleChangeCheckbox}
                name="customers"
              />
            }
            label="صاحبین بار"
          />
        )}
        {hasRule('can_manage_operators') && (
          <FormControlLabel
            control={
              <Checkbox
                checked={drivers}
                onChange={handleChangeCheckbox}
                name="drivers"
              />
            }
            label="رانندگان"
          />
        )}
        {hasRule('can_manage_operators') && (
          <FormControlLabel
            control={
              <Checkbox
                checked={operators}
                onChange={handleChangeCheckbox}
                name="operators"
              />
            }
            label="کارشناسان حمل"
          />
        )}
      </div>
      {(isAdmin || hasRule('can_download_commissions_excel')) && (
        <Button
          disabled={progress}
          startIcon={<SaveIcon />}
          style={{ backgroundColor: 'green', color: 'white', marginTop: 8 }}
          onClick={handleDownloadExcel}
          fullWidth={true}
        >
          Download Excel
        </Button>
      )}
    </Accordion>
  );
};

export default React.memo(Filters);
